import store from "@/store";

const tokenHelper = {
    getToken() {
      const token = store.state.token || localStorage.getItem("token");
      return token;
    },
    setToken(token, expire) {
      store.commit("setToken", token);
      localStorage.setItem("token", token);
    },
    clearToken() {
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
    },
  };
  
  export default tokenHelper;
